<template>
	<div class="container">
		<div
			class="course-info-container"
			aria-label="当前页面展示了课程信息，包括课程介绍、讲师介绍和章节列表三个部分，您可以在章节列表中，选中一个章节，这将弹出对应的小节列表，选择想学习的小节后，即可跳转学习页面。"
			tabindex="0"
		>
			<div
				class="navbar1"
			>
				<BackButton class="back-button" />
			</div>
			<img
				class="course-cover"
				:src="baseUrl+courseInfo.coverUrl"
				alt="课程封面"
				tabindex="0"
			>
			<h2
				class="title"
				tabindex="0"
			>课程介绍</h2>
			<p
				tabindex="0"
			>{{ courseInfo.courseDesc }}</p>
			<h2
				class="title"
				tabindex="0"
			>讲师介绍</h2>
			<p
				tabindex="0"
			>{{ courseInfo.teacherDesc }}</p>
			<h2
				class="title"
				tabindex="0"
			>章节列表</h2>
			<ul
				class="chapter-list"
				role="list"
			>
				<li
					v-for="(chapter, index) in chapters"
					:key="index"
					@click="handleChapterListClick(index)"
					@keydown.enter="handleChapterListClick(index)"
					role="listitem"
					:aria-label="chapter.chapterName + (expandedChapters[index] ? '已展开' : '已折叠')"
					aria-live="assertive"
					tabindex="0"
				>{{ chapter.chapterName }}
					<ul
						class="section-list"
						v-show="expandedChapters[index]"
						role="list"
					>
						<li
							v-for="(section, index1) in sections[chapter.chapterId]"
							:key="index1"
							@click="startToLearn(chapter.chapterId, index1)"
							@keydown.enter="startToLearn(chapter.chapterId, index1)"
							role="listitem"
							tabindex="0"
						>{{ section.sectionName }}</li>
					</ul>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import BackButton from '@/components/BackButton.vue';
import axios from 'axios';
import { baseUrl, fetchChaptersUrl, fetchSectionsUrl } from "@/constants/urls";

export default {
		data() {
			return {
				baseUrl: baseUrl,
				courseInfo: JSON.parse(this.$route.query.course),
				chapters: [],
				sections: {},
				expandedChapters: []
			}
		},
		components: {
			BackButton
		},
		created() {
			this.getChapters();
			this.expandedChapters=Array(this.chapters.length).fill(false);
		},
		methods:{
			getChapters(){
				const params={
					courseId: this.courseInfo.courseId
				};
				axios.get(baseUrl+fetchChaptersUrl, { params }).then(response => {
					this.chapters=response.data.data;
					this.getSections();
				});
			},
			getSections(){
				for (const chapter of this.chapters){
					const params={
						chapterId: chapter.chapterId
					};
					axios.get(baseUrl+fetchSectionsUrl, { params }).then(response => {
						this.sections[chapter.chapterId]=response.data.data;
					});
				}
			},
			handleChapterListClick(index){
				this.expandedChapters[index]=! this.expandedChapters[index];
			},
			startToLearn(chapterId, sectionIdx){
				this.$router.push({"name": "Learning", query: {sectionInfo: JSON.stringify(this.sections[chapterId][sectionIdx])}});
			}
		}
	}
</script>

<style scoped>
.container {
	display: flex;
	justify-content: center;
}

.navbar1 {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	height: 40px;
	margin-bottom: 10px;
}

.back-button {
	width: 20%;
	height: 100%;
}

.course-info-container {
	display: flex;
	flex-direction: column; /* 垂直排列 */
	justify-content: flex-start; /* 内容从顶部开始排列 */
	width: 50%;
	padding: 20px;          /* 添加内边距以美化布局 */
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 添加阴影 */
	border-radius: 8px;     /* 圆角 */
	background-color: #fff; /* 背景色 */
}

.course-cover {
	display: flex;
	align-self: center;
	width: 100%;
	height: auto;
	margin-top: 10px;
}

.title {
	border-bottom: 2px solid #000;
	padding-bottom: 10px;
}

@media (max-width: 500px){
	.navbar1 {
		margin-top: 10vh;
	}

	.course-info-container {
		width: 100%;
	}

	.back-button {
		width: 30%;
		font-size: 90%;
	}
}
</style>
